import { render, staticRenderFns } from "./CourseRegistrationInfo.vue?vue&type=template&id=1d4a91e8&"
import script from "./CourseRegistrationInfo.vue?vue&type=script&lang=ts&"
export * from "./CourseRegistrationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
